/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScopeContainsTenantQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScopeContainsTenantQueryOperator");
    }

    getFixupPrototypeFunction() { return ScopeContainsTenantQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ScopeContainsTenantQueryOperator>): ScopeContainsTenantQueryOperator {
        let obj = Object.assign(new ScopeContainsTenantQueryOperator(), model);
        ScopeContainsTenantQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScopeContainsTenantQueryOperator>): ScopeContainsTenantQueryOperator {
        if (!model) return null;
        return ScopeContainsTenantQueryOperator.newInstance(<ScopeContainsTenantQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScopeContainsTenantQueryOperator) {
        if (!obj) return;

        models.ScopeContainsTenantQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScopeContainsTenantQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScopeContainsTenantQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant IDs to include
     */
    tenant_ids: Array<string>;

}
